import * as React from 'react';
import cx from 'classnames';

export interface CKSelectListItemProps {
  isHighlighted: boolean;
  isSelected: boolean;
  isDisabled: boolean;
  accessoryRenderer?: React.ReactChildren;
  itemMetaRenderer?: React.ReactChildren;
}

export const CKSelectListItem: React.FC<CKSelectListItemProps> = React.forwardRef(
  (
    {
      children,
      isHighlighted,
      isSelected,
      isDisabled,
      itemMetaRenderer,
      accessoryRenderer,
      ...rest
    },
    ref: React.Ref<HTMLLIElement>
  ) => {
    const listItemClass = cx('ck-popover-options-item', {
      'ck-popover-options-item--highlighted': isHighlighted,
      'ck-popover-options-item--selected': isSelected,
      'ck-popover-options-item--disabled': isDisabled,
    });

    return (
      <li className={listItemClass} {...rest} ref={ref}>
        {accessoryRenderer && (
          <span className="ck-popover-options-item-accessory">
            {accessoryRenderer}
          </span>
        )}
        <span>{children}</span>
        {itemMetaRenderer && (
          <span className="ck-popover-options-item-meta">
            {itemMetaRenderer}
          </span>
        )}
      </li>
    );
  }
);
